module.exports = {"441721100":"织篢镇","441721101":"程村镇","441721102":"塘口镇","441721103":"上洋镇","441721104":"溪头镇","441721105":"沙扒镇","441721106":"儒洞镇","441721107":"新圩镇","441721502":"阳江林场儒洞分场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441721.json
// module id = 2170
// module chunks = 0